import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrganisationService } from './../../services/organisation.service';

@Component({
    selector: 'sb-number-input',
    templateUrl: './number-input.component.html',
    styleUrls: ['./number-input.component.scss'],
    standalone: false
})
export class NumberInputComponent implements OnInit {

  @Input() modelNumber: number;
  @Output() modelNumberChange: EventEmitter<number> = new EventEmitter();
  @Input() required: boolean;
  @Input() min: number; // Added for Angular 12
  @Input() max: number; // Added for Angular 12

  currencySymbol: string = '';

  constructor(private organisation: OrganisationService) {}

  ngOnInit() {
    this.organisation.getOrganisationCurrencySymbol().subscribe(symbol => {
      this.currencySymbol = symbol;
    });
  }

  onChange($event: number) {
    this.modelNumberChange.emit($event);
  }

}
